import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const BrandingTab = () => {
  const [brandingData, setBrandingData] = useState({
    companyName: "Invoice Parser Pro",
    companyLogo: "https://images.unsplash.com/photo-1712752968422-d63c0d68d01e",
    primaryColor: "#2563EB",
    secondaryColor: "#64748B",
    accentColor: "#059669",
    companyAddress: `123 Business Street\nLondon, EC1A 1BB\nUnited Kingdom`,
    companyPhone: "+44 20 7946 0958",
    companyEmail: "accounts@invoiceparser.co.uk",
    vatNumber: "GB123456789",
    companyNumber: "12345678"
  });

  const [logoPreview, setLogoPreview] = useState(null);

  const colorPresets = [
  { name: "Professional Blue", primary: "#2563EB", secondary: "#64748B", accent: "#059669" },
  { name: "Corporate Green", primary: "#059669", secondary: "#64748B", accent: "#2563EB" },
  { name: "Modern Purple", primary: "#7C3AED", secondary: "#64748B", accent: "#059669" },
  { name: "Classic Navy", primary: "#1E40AF", secondary: "#64748B", accent: "#F59E0B" },
  { name: "Elegant Gray", primary: "#374151", secondary: "#6B7280", accent: "#10B981" }];


  const handleInputChange = (field, value) => {
    setBrandingData((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleColorPreset = (preset) => {
    setBrandingData((prev) => ({
      ...prev,
      primaryColor: preset?.primary,
      secondaryColor: preset?.secondary,
      accentColor: preset?.accent
    }));
  };

  const handleLogoUpload = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e?.target?.result);
        setBrandingData((prev) => ({
          ...prev,
          companyLogo: e?.target?.result
        }));
      };
      reader?.readAsDataURL(file);
    }
  };

  const handleSaveBranding = () => {
    console.log('Saving branding data:', brandingData);
  };

  const handleResetToDefaults = () => {
    setBrandingData({
      companyName: "Invoice Parser Pro",
      companyLogo: "https://images.unsplash.com/photo-1712752968422-d63c0d68d01e",
      primaryColor: "#2563EB",
      secondaryColor: "#64748B",
      accentColor: "#059669",
      companyAddress: `123 Business Street\nLondon, EC1A 1BB\nUnited Kingdom`,
      companyPhone: "+44 20 7946 0958",
      companyEmail: "accounts@invoiceparser.co.uk",
      vatNumber: "GB123456789",
      companyNumber: "12345678"
    });
    setLogoPreview(null);
  };

  return (
    <div className="space-y-8">
      {/* Company Information */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Building2" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Company Information</h3>
            <p className="text-sm text-muted-foreground">Configure your company details for exports and branding</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-4">
            <Input
              label="Company Name"
              value={brandingData?.companyName}
              onChange={(e) => handleInputChange('companyName', e?.target?.value)}
              placeholder="Enter company name"
              required />


            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Company Address
              </label>
              <textarea
                value={brandingData?.companyAddress}
                onChange={(e) => handleInputChange('companyAddress', e?.target?.value)}
                placeholder="Enter full company address"
                rows={4}
                className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2" />

            </div>

            <Input
              label="Phone Number"
              value={brandingData?.companyPhone}
              onChange={(e) => handleInputChange('companyPhone', e?.target?.value)}
              placeholder="+44 20 7946 0958" />


            <Input
              label="Email Address"
              type="email"
              value={brandingData?.companyEmail}
              onChange={(e) => handleInputChange('companyEmail', e?.target?.value)}
              placeholder="accounts@company.co.uk" />

          </div>

          <div className="space-y-4">
            <Input
              label="VAT Registration Number"
              value={brandingData?.vatNumber}
              onChange={(e) => handleInputChange('vatNumber', e?.target?.value)}
              placeholder="GB123456789"
              description="UK VAT registration number" />


            <Input
              label="Company Registration Number"
              value={brandingData?.companyNumber}
              onChange={(e) => handleInputChange('companyNumber', e?.target?.value)}
              placeholder="12345678"
              description="Companies House registration number" />


            {/* Logo Upload */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Company Logo
              </label>
              <div className="flex items-center space-x-4">
                <div className="w-20 h-20 border-2 border-dashed border-border rounded-lg flex items-center justify-center overflow-hidden">
                  {logoPreview || brandingData?.companyLogo ?
                  <Image
                    src={logoPreview || brandingData?.companyLogo}
                    alt="Company logo preview showing business branding"
                    className="w-full h-full object-cover" /> :


                  <Icon name="Building2" size={24} className="text-muted-foreground" />
                  }
                </div>
                <div className="flex-1">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleLogoUpload}
                    className="hidden"
                    id="logo-upload" />

                  <label htmlFor="logo-upload">
                    <Button variant="outline" size="sm" iconName="Upload" iconPosition="left">
                      Upload Logo
                    </Button>
                  </label>
                  <p className="text-xs text-muted-foreground mt-1">
                    PNG, JPG up to 2MB. Recommended: 200x200px
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Color Scheme */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="Palette" size={20} className="text-accent" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Color Scheme</h3>
            <p className="text-sm text-muted-foreground">Customize your application colors</p>
          </div>
        </div>

        {/* Color Presets */}
        <div className="mb-6">
          <h4 className="text-sm font-medium text-foreground mb-3">Quick Presets</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {colorPresets?.map((preset, index) =>
            <button
              key={index}
              onClick={() => handleColorPreset(preset)}
              className="p-3 border border-border rounded-lg hover:border-primary transition-smooth">

                <div className="flex space-x-1 mb-2">
                  <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: preset?.primary }} />

                  <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: preset?.secondary }} />

                  <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: preset?.accent }} />

                </div>
                <div className="text-xs text-foreground font-medium">{preset?.name}</div>
              </button>
            )}
          </div>
        </div>

        {/* Custom Colors */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Primary Color
            </label>
            <div className="flex items-center space-x-3">
              <input
                type="color"
                value={brandingData?.primaryColor}
                onChange={(e) => handleInputChange('primaryColor', e?.target?.value)}
                className="w-12 h-10 border border-border rounded cursor-pointer" />

              <Input
                value={brandingData?.primaryColor}
                onChange={(e) => handleInputChange('primaryColor', e?.target?.value)}
                placeholder="#2563EB"
                className="flex-1" />

            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Secondary Color
            </label>
            <div className="flex items-center space-x-3">
              <input
                type="color"
                value={brandingData?.secondaryColor}
                onChange={(e) => handleInputChange('secondaryColor', e?.target?.value)}
                className="w-12 h-10 border border-border rounded cursor-pointer" />

              <Input
                value={brandingData?.secondaryColor}
                onChange={(e) => handleInputChange('secondaryColor', e?.target?.value)}
                placeholder="#64748B"
                className="flex-1" />

            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Accent Color
            </label>
            <div className="flex items-center space-x-3">
              <input
                type="color"
                value={brandingData?.accentColor}
                onChange={(e) => handleInputChange('accentColor', e?.target?.value)}
                className="w-12 h-10 border border-border rounded cursor-pointer" />

              <Input
                value={brandingData?.accentColor}
                onChange={(e) => handleInputChange('accentColor', e?.target?.value)}
                placeholder="#059669"
                className="flex-1" />

            </div>
          </div>
        </div>

        {/* Live Preview */}
        <div className="mt-6 p-4 bg-muted/50 rounded-lg">
          <h4 className="text-sm font-medium text-foreground mb-3">Live Preview</h4>
          <div className="flex items-center space-x-4">
            <Button
              style={{ backgroundColor: brandingData?.primaryColor, borderColor: brandingData?.primaryColor }}>

              Primary Button
            </Button>
            <Button
              variant="outline"
              style={{ borderColor: brandingData?.secondaryColor, color: brandingData?.secondaryColor }}>

              Secondary Button
            </Button>
            <div
              className="px-3 py-1 rounded-full text-white text-sm"
              style={{ backgroundColor: brandingData?.accentColor }}>

              Accent Badge
            </div>
          </div>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex items-center justify-between pt-6 border-t border-border">
        <Button
          variant="outline"
          onClick={handleResetToDefaults}
          iconName="RotateCcw"
          iconPosition="left">

          Reset to Defaults
        </Button>
        
        <Button
          onClick={handleSaveBranding}
          iconName="Save"
          iconPosition="left">

          Save Branding
        </Button>
      </div>
    </div>);

};

export default BrandingTab;